import type { BulkCommandEntry } from '@ayumia/component-runtime';
import { text } from '../../app/i18n';

/**
 * Actions groupées déclarées (ADR-149 §3) : une entrée de `bulk_commands` est un nom de commande
 * (forme de 1.7.0) ou un objet à bornes, confirmation et variante. Présentation seulement : hors
 * bornes, l'action est grisée et dit pourquoi ; le serveur borne et réautorise de toute façon.
 */

export interface BulkActionSpec {
  command_name: string;
  label?: string;
  icon?: string;
  min: number;
  max?: number;
  /** Confirmation demandée (toujours pour une action destructive). */
  confirm: { title?: string; message?: string } | null;
  danger: boolean;
  appliesTo: 'items' | 'folders' | 'all';
}

export function bulkActionSpec(entry: BulkCommandEntry): BulkActionSpec {
  if (typeof entry === 'string') return { command_name: entry, min: 1, confirm: null, danger: false, appliesTo: 'items' };
  const danger = entry.variant === 'danger';
  const declared = entry.confirm;
  const confirm = declared === undefined || declared === false ? (danger ? {} : null) : declared === true ? {} : { ...(declared.title === undefined ? {} : { title: text(declared.title) }), ...(declared.message === undefined ? {} : { message: text(declared.message) }) };
  return {
    command_name: entry.command_name,
    ...(entry.label === undefined ? {} : { label: text(entry.label) }),
    ...(entry.icon === undefined ? {} : { icon: entry.icon }),
    min: entry.min_selection ?? 1,
    ...(entry.max_selection === undefined ? {} : { max: entry.max_selection }),
    confirm,
    danger,
    appliesTo: entry.applies_to ?? 'items',
  };
}

/** Disponibilité d'une action pour `count` éléments : grisée hors bornes, avec la raison dite. */
export function bulkAvailability(spec: Pick<BulkActionSpec, 'min' | 'max'>, count: number): { enabled: boolean; reason?: string } {
  if (count < spec.min) return { enabled: false, reason: `Choisissez au moins ${spec.min.toLocaleString('fr')} élément${spec.min > 1 ? 's' : ''}.` };
  if (spec.max !== undefined && count > spec.max) return { enabled: false, reason: `${spec.max.toLocaleString('fr')} élément${spec.max > 1 ? 's' : ''} au plus à la fois.` };
  return { enabled: true };
}
